import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./components/account/Login";
import TokenAuth from "./components/account/TokenAuth";
import CustomServices from "./components/support/CustomServices";
import OffMaintenance from "./components/support/OffMaintenance";
import TrainingRequest from "components/support/TrainingRequest";
import Unavailable from "components/support/Unavailable";
import FieldConfiguration from "components/admin/FieldConfiguration";

import { CompanyProvider } from "./lib/context/CompanyContext";
import { StatusMessageProvider } from "./lib/context/StatusMessageContext";

function App() {
  return (
    <div>
      <CompanyProvider>
        <StatusMessageProvider>
          <Router>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/auth/field" component={TokenAuth} />
              <Route
                exact
                path="/support/off-maintenance"
                component={OffMaintenance}
              />
              <Route
                exact
                path="/support/custom-services"
                component={CustomServices}
              />
              <Route
                exact
                path="/support/training-request"
                component={TrainingRequest}
              />
              <Route
                exact
                path="/support/unavailable"
                component={Unavailable}
              />
              <Route
                path="/admin/field-configuration"
                component={FieldConfiguration}
              />
            </Switch>
          </Router>
        </StatusMessageProvider>
      </CompanyProvider>
    </div>
  );
}

export default App;
